import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';

import { MatSnackBar } from '@angular/material';
import { DoctorService } from '../services/doctor.service';
import { CommonService } from '../services/common.service';
@Component({
  selector: 'app-otpconfirmation',
  templateUrl: './otpconfirmation.component.html',
  styleUrls: ['./otpconfirmation.component.css']
})
export class OtpconfirmationComponent implements OnInit {
  otpdata: any;
  loading = false;
  user_id: any;
  msg: any;
  action: any;
  constructor(public dialog: MatDialog, public dialogref: MatDialogRef<OtpconfirmationComponent>,
  public doctorservice: DoctorService, private commonService: CommonService,  private snackbar: MatSnackBar) {
    const udata = this.commonService.getUserDataLocally();
    this.user_id = udata.uid;
  }

  ngOnInit() {
  }
  verifyUser() {
    this.loading = true;
    this.doctorservice.getCommentedUserDetail(this.user_id)
    .subscribe(
      (x) => {
        this.loading = false;
        const temp = x[0].otp;
        if (temp == this.otpdata) {
          this.verifiedUser();
        }else {
          this.msg = 'invalid otp';
          this.openSnackBar();
        }
       });
  }
  verifiedUser() {
    this.loading = true;
    this.commonService.verifyuser(this.user_id)
    .subscribe(
      (x) => {
        this.loading = false;
        this.closeDialog(1);
      });
  }
  closeDialog(result) {
    this.dialogref.close(result);
  }
  openSnackBar() {
    this.snackbar.open(this.msg , this.action, {
      duration: 4000,
    });
  }
}
